module.exports = __webpack_public_path__ + "static/media/status_Completed_Green.e83c3873.svg";